import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Badge } from 'react-bootstrap';
const ActivityCountCard = ({ activity }) => {
    return (_jsx(Card, { className: "h-100", children: _jsxs(Card.Body, { className: "d-flex justify-content-between align-items-center p-3", children: [_jsx("span", { className: "text-truncate me-2 fw-medium", style: { fontSize: 'var(--font-size-sm)' }, children: activity.activityName }), _jsx(Badge, { bg: "info", className: "flex-shrink-0", style: { fontSize: 'var(--font-size-xs)' }, children: activity.count })] }) }));
};
export default ActivityCountCard;
